import { Modal, Input, Spin, Table } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import { getMTOColumns } from "./columnDefinitions";

const MakeToOrderModal = ({
  mtoModalVisible,
  setMtoModalVisible,
  setChooseProductsData,
  searchTextOrder,
  setSearchTextOrder,
  setLoading,
  loading,
  handleSearchedOrder,
  handleOrderScroll,
  tableRef,
  chooseProductsData,
  updateChooseProductsData,
  handleChooseProductSelect,
}) => {
  const columns = getMTOColumns({ updateChooseProductsData, handleChooseProductSelect });

  return (
    <Modal
      title="Select Product for Production"
      open={mtoModalVisible}
      onCancel={() => {
        setMtoModalVisible(false);
        setChooseProductsData([]);
        setSearchTextOrder("");
        setLoading(false);
      }}
      footer={null}
      width={900}
      maskClosable={true}
      centered={true}
      styles={{ body: { padding: "16px" } }}
    >
      <Input
        style={{ width: "50%" }}
        placeholder="Search for products by code/name"
        value={searchTextOrder}
        onChange={(e) => setSearchTextOrder(e.target.value)}
        onPressEnter={() => handleSearchedOrder()}
      />
      <Spin spinning={loading}>
        <Scrollbars ref={tableRef} className="productionScroll" onScrollFrame={handleOrderScroll}>
          <Table
            className="sm-cart-table-pos"
            tableLayout="fixed"
            columns={columns}
            dataSource={chooseProductsData}
            pagination={false}
            rowKey="id"
            styles={{ body: { padding: "16px" } }}
          />
        </Scrollbars>
      </Spin>
    </Modal>
  );
};

export default MakeToOrderModal;
